import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-322f0fca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order-title" }
const _hoisted_3 = { class: "order-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "order-item"
}
const _hoisted_7 = { class: "order-item-icon" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "red-dot"
}
const _hoisted_10 = { class: "order-item-name" }
const _hoisted_11 = {
  key: 0,
  class: "order-item"
}

import { ref, watch, watchEffect, Ref } from 'vue'
import { t } from '@/plugins/i18n'
import { CustomerShopRespDTO, DeliveryAbnormalOrderCount } from '@/apis/interface/customer'
import { OrderTypeItem } from './UserOrder.vue'
import { useRtfix, isD2C, isJA, isKO, isEN } from '@/store'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { useRouter } from 'vue-router'

enum ENUM_GOODS {
    /** 在库商品 */
    INVENTORY_PRODUCT = '1',
    /** 未关联的商品 */
    UNASSOCIATED_PRODUCT = '2',
    /** 组合商品落单 */
    COMBINATION_PRODUCT = '3'
}

export default /*#__PURE__*/_defineComponent({
  props: {
    overviewInfo: { type: null, required: true },
    workbenchOrderInfo: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
    overviewInfo: CustomerShopRespDTO,
    workbenchOrderInfo: DeliveryAbnormalOrderCount
}
const router = useRouter()
const orderTypeList2C: OrderTypeItem[] = [
  {
    name: t('在库商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/在库商品.svg',
    num: 0,
    orderStatus: ENUM_GOODS.INVENTORY_PRODUCT,
    position: 'inventory_product'
  },
  {
    name: t('未关联的商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/未关联的商品.svg',
    num: 0,
    orderStatus: ENUM_GOODS.UNASSOCIATED_PRODUCT,
    position: 'unrelated_product'
  },
  {
    name: t('组合商品落单'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/组合商品落单.svg',
    num: 0,
    orderStatus: ENUM_GOODS.COMBINATION_PRODUCT,
    position: 'combination_product_placement'
  }
]

const orderTypeList2B: OrderTypeItem[] = [
  {
    name: t('在库商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/在库商品.svg',
    num: 0,
    orderStatus: ENUM_GOODS.INVENTORY_PRODUCT,
    position: 'inventory_product'
  },
  {
    name: t('组合商品落单'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/组合商品落单.svg',
    num: 0,
    orderStatus: ENUM_GOODS.COMBINATION_PRODUCT,
    position: 'combination_product_placement'
  }
]

const orderTypeList: Ref<OrderTypeItem[]> = ref(isD2C() ? orderTypeList2C : orderTypeList2B)


watchEffect(() => {
  const newArr = [...orderTypeList.value]
  newArr.map((item) => {
    if (item.orderStatus === ENUM_GOODS.INVENTORY_PRODUCT) {
      item.num = props?.overviewInfo?.productAmount || 0
    } else if (item.orderStatus === ENUM_GOODS.UNASSOCIATED_PRODUCT) {
      item.num = props.workbenchOrderInfo?.noBindApiSkuCount || 0
    } else if (item.orderStatus === ENUM_GOODS.COMBINATION_PRODUCT) {
      item.num = props.overviewInfo?.combinationFallAmount || 0
    }
  })
})

const handleAppLink = (item: OrderTypeItem) => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: { position: item.position }
  })
  if (item.orderStatus === ENUM_GOODS.INVENTORY_PRODUCT) {
    return router.push(useRtfix('stock'))
  } else if (item.orderStatus === ENUM_GOODS.UNASSOCIATED_PRODUCT) {
    return router.push(useRtfix('AssociatedProductlib', { query: { bindStatus: 0 } }))
  } else if (item.orderStatus === ENUM_GOODS.COMBINATION_PRODUCT) {
    return router.push(useRtfix('CombinedGoods', { query: { existWaitCombinationFlag: 1 } }))
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('商品管理')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderTypeList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.orderStatus,
          onClick: ($event: any) => (handleAppLink(item)),
          class: "order-item"
        }, [
          (!_unref(isJA)() && item.orderStatus === ENUM_GOODS.COMBINATION_PRODUCT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: item.icon
                  }, null, 8, _hoisted_8),
                  (Number(item?.num) > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["order-item-num", Number(item?.num) > 0 ? 'is-red': ''])
                }, _toDisplayString(item.num), 3),
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1)
              ]))
        ], 8, _hoisted_4))
      }), 128)),
      (!_unref(isD2C)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_11))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})